module.exports = __webpack_public_path__ + "static/media/ChangEKitchenINTA0014_design_clean_v003.34a47c5b.png";